import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../Structure/components/Head/Head';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../Shared/components/Alerts/AlertsConteiner';
import {browserHistory} from 'react-router';
import WaitBlock from '../../Shared/components/Alerts/WaitBlock';
import {changeStepWaitBlock, showWaitBlock} from '../../Structure/actions/actionsStructure';
import {changePassword, checkIsLogin} from '../actions/actionsAdmin';
import InputPassword from "../../Shared/components/Forms/input/inputPassword";
import {PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN, PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL} from "../../../App/RouterAdopta";

class ChangePasswordPage extends Component {
    constructor(props) {
        super(props);
        this.props.checkIsLogin();
        
        this.state = {
            oldPassword: '',
            newPassword: '',
            repeatPassword: '',
        };
        
        this.oldPassword = {
            inlineIcon: 'form-control-inline-icon inline-icon-right',
            controlValidate: 'validateForm',
            iconSpan: 'icon-login-color las la-lg la-key',
            columns: 'col-lg-12',
            id: 'oldPassword',
            placeHolder: 'Contraseña anterior',
            methodChange: this.changeOldPassword.bind(this),
        };
        
        this.newPassword = {
            inlineIcon: 'form-control-inline-icon inline-icon-right',
            controlValidate: 'validateForm',
            iconSpan: 'icon-login-color las la-lg la-key',
            columns: 'col-lg-12',
            id: 'newPassword',
            type: 'password',
            placeHolder: 'Contraseña',
            methodChange: this.changeNewPassword.bind(this),
        };
        
        this.passwordRepeat = {
            inlineIcon: 'form-control-inline-icon inline-icon-right',
            controlValidate: 'validateForm',
            iconSpan: 'icon-login-color las la-lg la-key',
            columns: 'col-lg-12',
            id: 'passwordRepeat',
            type: 'password',
            placeHolder: 'Repita Contraseña',
            methodChange: this.changeRepeatPassword.bind(this),
        };
        
        this.EventWaitBlock = this.EventWaitBlock.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.changePasswordSubmit = this.changePasswordSubmit.bind(this);
        this.changeOldPassword = this.changeOldPassword.bind(this);
        this.changeNewPassword = this.changeNewPassword.bind(this);
        this.changeRepeatPassword = this.changeRepeatPassword.bind(this);
    }
    
    changeOldPassword(value, elementId) {
        this.setState({
            oldPassword: value,
        });
    }
    
    changeNewPassword(value, elementId) {
        this.setState({
            newPassword: value,
        });
    }
    
    changeRepeatPassword(value, elementId) {
        this.setState({
            passwordRepeat: value,
        });
    }
    
    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    
    changePasswordSubmit(e) {
        //Comprobar que todos los campos son correctos.
        let errorMessage = '';
        let passwordNoIguales = false;
        const oldPassword = $('#oldPassword');
        const newPassword = $('#newPassword');
        const passwordRepeat = $('#passwordRepeat');
        
        if (oldPassword.val() === '') {
            oldPassword.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === '') {
                errorMessage = 'Contraseña anterior';
            } else {
                errorMessage += ', contraseña anterior';
            }
        } else {
            oldPassword.removeClass('formInputError');
        }
        
        if (newPassword.val() === '') {
            newPassword.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === '') {
                errorMessage = 'Nueva contraseña';
            } else {
                errorMessage += ', nueva contraseña';
            }
        } else {
            newPassword.removeClass('formInputError');
        }
        
        if (passwordRepeat.val() === '') {
            passwordRepeat.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === '') {
                errorMessage = 'Contraseña';
            } else {
                errorMessage += ', contraseña';
            }
        } else {
            if (newPassword.val() !== passwordRepeat.val()) {
                passwordNoIguales = true;
            }
            passwordRepeat.removeClass('formInputError');
        }
        
        Alert.closeAll();
        if (errorMessage !== '') {
            e.preventDefault();
            Alert.warning('Los siguientes campos son obligatorios: ' + errorMessage, {
                position: 'top-right',
                effect: 'slide',
                timeout: 3000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: 'las la-2x la-exclamation-triangle',
                },
            });
        } else if (passwordNoIguales) {
            
            Alert.warning('Las contraseñas nuevas no coinciden', {
                position: 'top-right',
                effect: 'slide',
                timeout: 3000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: 'las la-2x la-exclamation-triangle',
                },
            });
        } else {
            e.preventDefault();
            this.props.changeWaitBlock(true);
        }
    }
    
    EventWaitBlock(event) {
        if (event === 'go') {
            this.props.changePassword(this.state, this.props.access);
        } else {
            if (this.props.stepWaitBlock === 200) {
                Alert.success(
                    'Contraseña cambiada correctamente.',
                    {
                        position: 'top-right',
                        effect: 'slide',
                        timeout: 6000,
                        customFields: {
                            messageItem: 2,
                            showIconClosed: true,
                            icon: 'las la-2x la-exclamation-triangle',
                        },
                    }
                );
            } else {
                Alert.error('Error: ' + this.props.errorWaitBlock, {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: 'las la-2x la-exclamation-triangle',
                    },
                });
            }
            this.props.changeStepWaitBlock(0);
            this.props.changeWaitBlock(false);
        }
    }
    
    goLogin() {
        // let animationEnd =
        //   'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        // $('.page-login')
        //   .removeClass('animated fadeIn')
        //   .addClass('animated fadeOut')
        //   .one(animationEnd, () => {
        
        if (this.props && this.props.location && this.props.location.query && this.props.location.query.from) {
            browserHistory.push(this.props.location.query.from);
        } else {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL);
        }
        // });
    }
    
    render() {
        return (
            <div>
                <Head previousPath={'login'}/>
                {this.props.showWaitBlock && (
                    <WaitBlock
                        message={'Espere por favor...'}
                        methodChange={this.EventWaitBlock}
                    />
                )}
                <div className="page-login main-content">
                    <div className="container">
                        <div className="page-login__wrap">
                            <h2 className="page-login__heading">
                                ¡Nos alegra verte de vuelta!
                            </h2>
                            <p className="page-login__description">
                                <br/>
                                "Introduce los siguientes datos para cambiar tu contraseña"
                            </p>
                            <form action="#" className="page-login__form">
                                <div className="row justify-content-center">
                                    <InputPassword
                                        configInput={this.oldPassword}
                                    />
                                </div>
                                <div className="row justify-content-center">
                                    <InputPassword
                                        configInput={this.newPassword}
                                    />
                                </div>
                                <div className="row justify-content-center">
                                    <InputPassword
                                        configInput={this.passwordRepeat}
                                    />
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <div className="form-group mb-0">
                                            <button
                                                onClick={this.changePasswordSubmit}
                                                type="button"
                                                className="btn btn-primary btn-block page-login__submit-btn btn-hover"
                                            >
                                                Cambiar contraseña
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <footer className="page-login__form-footer">
                                <button onClick={() => this.goLogin()}
                                        className="btn btn-outline-secondary page-login__signup-btn">
                                    Volver
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
                <Alert
                    stack={true}
                    html={true}
                    contentTemplate={AlertsConteiner}
                />
            </div>
        );
    }
    
    componentWillMount() {
        if (!this.props.access.isLogin) {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
        }
        
        //Initial scroll
        let element = $('body');
        if (element.length !== 0) {
            //console.log("Haciendo scrollTop");
            $('body,html').stop(true, true).animate({scrollTop: element.offset().top,}, 100
            );
        }
        
        this.props.changeWaitBlock(false);
        this.props.changeStepWaitBlock(0);
    }
    
    componentDidMount() {
        // $('.page-login').addClass('animated fadeIn');
        $('.page-login').show();
        // let animationEnd =
        //   'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        
        if (!this.props.showHead) {
            // $('.header-topbar')
            //   .addClass('animated fadeInDown')
            //   .one(animationEnd, () => {
            $('.header-topbar').removeClass('animated fadeInDown');
            // });
            $('.header-topbar').css('visibility', 'visible');
        } else {
            // $('.header-topbar').removeClass('animated fadeInDown');
            $('.header-topbar').css('visibility', 'visible');
        }
        
        if (!this.props.showFooter) {
            // $('.footer-default').addClass('animated fadeIn');
            $('.footer-default').show();
        } else {
            // $('.footer-default').removeClass('animated fadeIn');
            $('.footer-default').show();
        }
        
        //$('#user').focus();
    }
    
    componentDidUpdate() {
        if (this.props.showWaitBlock) {
            $('#modal-container').removeClass('out').addClass('one');
            $('body').addClass('modal-active');
        } else {
            $('body').removeClass('modal-active');
        }
    }
}

function mapStateToProps(state) {
    return {
        showHead: state.structureControl.showHead,
        showFooter: state.structureControl.showFooter,
        showWaitBlock: state.structureControl.showWaitBlock,
        stepWaitBlock: state.structureControl.stepWaitBlock,
        errorWaitBlock: state.structureControl.errorWaitBlock,
        access: state.access,
    };
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    changeWaitBlock: showWaitBlock,
    changeStepWaitBlock,
    changePassword,
    checkIsLogin
})(ChangePasswordPage);
